import React from 'react';
import { Link } from 'react-router-dom';
export const TeamPage = () => {
  const teamMembers = [{
    name: 'Alfred Chuang',
    title: 'General Partner',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771635850/62e0202ed964cd704aad3b33_1590614887781_jrblvj.jpg',
    slug: 'alfred-chuang'
  }, {
    name: 'Chris McCann',
    title: 'General Partner',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771635851/62e0202ed964cd1395ad3bae_Chris_qjvjzq.png',
    slug: 'chris-mccann'
  }, {
    name: 'Matt McLaughlin',
    title: 'Senior Operating Partner',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771635857/67812d6064cbde074e7c95ca_Untitled_w9u9lx.png',
    slug: 'matt-mclaughlin'
  }, {
    name: 'Edith Yeung',
    title: 'Founding Partner',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771635850/62e0202ed964cd85dead3b1d_1611126496277_nt3f13.jpg',
    slug: 'edith-yeung'
  }, {
    name: 'Kelly Cheng',
    title: 'CFO',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771635853/670e90e438f68b665e0edbe5_Untitled_fj6tnr.png',
    slug: 'kelly-cheng'
  }, {
    name: 'Bernard Chan',
    title: 'Investor',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771635852/67e17e811118b5f0ccc4a399_Bernard_Profile_hhxnby.png',
    slug: 'bernard-chan'
  }, {
    name: 'Mohak Saxena',
    title: 'Investor',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771635854/674ddd11189fcab109c08bf5_Screenshot_2024-12-02_at_4.15.10_PM_ydbxcz.png',
    slug: 'mohak-saxena'
  }, {
    name: 'Alim Giga',
    title: 'Investor',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771635854/68bf2ba3917662bb9ba49c74_Alim-2_kkqplx.png',
    slug: 'alim-giga'
  }, {
    name: 'Elizabeth Candelaria',
    title: 'Senior EA',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771635856/6501d75a036f656d0f3a3c6a_62e0202ed964cd8da9ad3b7f_Elizabeth-Candelaria-small_zxwzw3.jpg',
    slug: 'elizabeth-candelaria'
  }, {
    name: 'Mariah Cole',
    title: 'Office Manager',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771635859/692636fd5a0dcdf8242b5689_Mariah__Race_Capital_a1idfg.png',
    slug: 'mariah-cole'
  }];
  return <div className="w-full bg-white mt-20" data-id="element-340">
      {/* Combined Hero and Team Members Section */}
      <section className="w-full pt-20 pb-20 px-6 md:px-12 bg-white" data-id="element-341">
        <div className="max-w-7xl mx-auto" data-id="element-342">
          <div className="relative mb-6 overflow-visible" data-id="element-343">
            {/* Racing stripes decoration - animated and flowing */}
            <style jsx data-id="element-344">{`
              @keyframes fillFromLeft {
                from {
                  transform: scaleX(0);
                  transform-origin: left;
                }
                to {
                  transform: scaleX(1);
                  transform-origin: left;
                }
              }
              .racing-stripe {
                transform: scaleX(0);
                transform-origin: left;
                animation: fillFromLeft 0.8s ease-out forwards;
              }
              .racing-stripe:nth-child(1) {
                animation-delay: 0.1s;
              }
              .racing-stripe:nth-child(2) {
                animation-delay: 0.2s;
              }
              .racing-stripe:nth-child(3) {
                animation-delay: 0.3s;
              }
              .racing-stripe:nth-child(4) {
                animation-delay: 0.4s;
              }
            `}</style>
            <div className="absolute right-[12px] top-0 hidden md:flex flex-col space-y-2 pointer-events-none" data-id="element-345">
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/30 to-red-600/10" style={{
              width: '240px',
              marginLeft: '0px'
            }} data-id="element-346"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/35 to-red-600/15" style={{
              width: '200px',
              marginLeft: '40px'
            }} data-id="element-347"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/40 to-red-600/20" style={{
              width: '160px',
              marginLeft: '80px'
            }} data-id="element-348"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/45 to-red-600/25" style={{
              width: '120px',
              marginLeft: '120px'
            }} data-id="element-349"></div>
            </div>
            <h1 className="relative z-10 text-[clamp(2.5rem,5vw,4rem)] font-semibold text-[#070707] tracking-tight leading-[1.15]" data-id="element-350">
              Our Team
            </h1>
          </div>
          <p className="text-lg text-gray-600 max-w-3xl mb-16 leading-relaxed font-light" data-id="element-351">
            Race Capital is led by experienced entrepreneurs and investors with
            decades of experience to help entrepreneurs navigate the challenges
            of building category-defining businesses.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10" data-id="element-352">
            {teamMembers.map((member, index) => <div key={index} className="flex flex-col group" data-id="element-353">
                <Link to={`/team/${member.slug}`} className="block" data-id="element-354">
                  <div className="relative mb-4 aspect-square overflow-hidden rounded-2xl bg-gray-100 transition-all duration-300 group-hover:shadow-2xl" data-id="element-355">
                    <img src={member.image} alt={member.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-356" />
                  </div>
                  <h3 className="text-xl font-semibold text-[#070707] mb-2 group-hover:text-red-600 transition-colors" data-id="element-357">
                    {member.name}
                  </h3>
                  <p className="text-red-600 font-medium" data-id="element-358">{member.title}</p>
                </Link>
              </div>)}
          </div>
        </div>
      </section>
      {/* Values Section */}
      <section className="w-full py-20 px-6 md:px-12 bg-gradient-to-b from-gray-50/50 to-white" data-id="element-359">
        <div className="max-w-7xl mx-auto" data-id="element-360">
          <h2 className="text-4xl font-bold text-[#070707] mb-16 tracking-tight" data-id="element-361">
            Our Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-362">
            {[{
            icon: '⚮',
            title: 'Founder-First',
            description: 'Not a slogan—how we actually operate. Your company, your call. We give you our honest take, then back your decision fully.'
          }, {
            icon: '⚡',
            title: 'Partnership',
            description: "We view ourselves almost like a co-founder with minority ownership. In the hard moments, we're in it with you - not just checking up occasionally."
          }, {
            icon: '✦',
            title: 'Long Horizon',
            description: 'We optimize for the decade, not individual investments. Trust over optics, relationship over transaction.'
          }].map((value, index) => <div key={index} className="bg-white p-10 rounded-3xl border border-gray-100 hover:shadow-[0_4px_12px_rgba(0,0,0,0.06)] transition-all duration-300 group relative" data-id="element-363">
                <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-red-600 transform scale-y-0 group-hover:scale-y-100 transition-all origin-top rounded-l-3xl" data-id="element-364"></div>
                <div className="text-5xl text-red-600 mb-8 font-light" data-id="element-365">
                  {value.icon}
                </div>
                <h3 className="text-2xl font-semibold mb-4 text-[#070707]" data-id="element-366">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm" data-id="element-367">
                  {value.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
};